var map = {
	"./bell.svg": "ec9c",
	"./blue-help.svg": "0ba7",
	"./blue-information-circle.svg": "7124",
	"./book-blue.svg": "c53f",
	"./card-close.svg": "68d4",
	"./circle-plus.svg": "67e0",
	"./device-desktop.svg": "90e5",
	"./device-mobile.svg": "ffc9",
	"./device-tablet.svg": "1e1d",
	"./document.svg": "1344",
	"./expand-more.svg": "e1b8",
	"./facebook.svg": "8b07",
	"./fire.svg": "8a93",
	"./floating-icon.svg": "11fa",
	"./fullscreen-icon.svg": "ba4a",
	"./gamified-icon.svg": "c61d",
	"./green-success-circle-lg.svg": "fc63",
	"./green-success-circle.svg": "874c",
	"./green-success.svg": "19a3",
	"./grey-help-circle.svg": "8b5f",
	"./grey-information-circle.svg": "7af1",
	"./help-circle.svg": "c1b3",
	"./help-white-solid.svg": "f444",
	"./help-white.svg": "f208",
	"./inline-icon.svg": "92ab",
	"./nav-close.svg": "f9ba",
	"./open-book.svg": "3c1f",
	"./orange-warning-circle.svg": "bacb",
	"./play-icon.svg": "5806",
	"./popup-icon.svg": "4d06",
	"./red-alert-circle.svg": "d006",
	"./redx-hollow.svg": "3d48",
	"./redx.svg": "111f",
	"./rocket-blue.svg": "fd4f",
	"./rocket.svg": "df02",
	"./scheduled.svg": "9bca",
	"./search.svg": "f919",
	"./slide-icon.svg": "7f5d",
	"./split.svg": "0d33",
	"./twitter.svg": "974d",
	"./university.svg": "56f8",
	"./white-checkmark.svg": "1dda",
	"./white-right-arrow.svg": "109d",
	"./youtube.svg": "63ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0bd";